import { QUOTES_TYPE, quotesTypeFullName } from "../types/index.const";

const productTypeOptions = QUOTES_TYPE.slice(0, 7).map((el, index) => ({
  label: quotesTypeFullName[index],
  value: el,
}));

export default productTypeOptions;
